import React from 'react';

class FaqButtonService extends React.Component {

    constructor(props) {
        super(props);
        this.DEFAULT_TIME_OUT_BEFORE_CONFIRMATION = 3000000;
        this.DEFAULT_TIME_OUT_AFTER_CONFIRMATION = 3600000;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;
        this.isSwapSite = this.props.isSwapSite;
        this.state = {
            booking: null,
            hash: null,
            paymentConfirmation: null,
            error: null,
            timeOutBeforeConfirmation: this.DEFAULT_TIME_OUT_BEFORE_CONFIRMATION, // milliseconds...
            timeOutAfterConfirmation: this.DEFAULT_TIME_OUT_AFTER_CONFIRMATION, // milliseconds...
            initialRemainingTime: 600000,
            showCountDownUnder: 10000,
            showModal: false,
            activeComponentInMain: 'verification',
            sessionExpired: false,
            remainingTimeFunction: null
        }

    }
    
    faqButtonService = () => {
	   	let xhttp = new XMLHttpRequest();
	   	let helpURLClean = this.getStoreAttValue('HLP').replace('hc/en-us', '');
	   	let faqButtonServiceURI = helpURLClean + '/api/v2/help_center/en-us/categories.json';
	   	xhttp.open("GET", faqButtonServiceURI, true);
	   	xhttp.setRequestHeader("Accept", "application/json");
	   	xhttp.onreadystatechange = function() { 
	   	    if (this.readyState === 4 && this.status === 200) {
	   	    	document.getElementById("faqButtonContainerWrapper").innerHTML = '';
	   	        let buttonCollection = JSON.parse(xhttp.response);
		 	   	for(let k=0; k<buttonCollection.categories.length; k++){
		 	   		let newButton = '';
		 	   		newButton = document.createElement("a");
		 	   		newButton.setAttribute("id", "cssLogin_button_" + k);
		 	   		newButton.innerHTML = buttonCollection.categories[k].name;
		 	   		newButton.setAttribute("target", "_blank");
		 	   		newButton.setAttribute("onClick", "CallTracker('BCSS Login', this.innerHTML, '')");
		 	   		newButton.setAttribute("href", buttonCollection.categories[k].html_url);
		 	   		newButton.classList.add("ui-btn", "ui-shadow", "ui-corner-all", "ui-mini", "wth2-grayBtn");	
		 	   		newButton.classList.add("wth2-cssLogin_faqButtonPadding");
		 	   		newButton.classList.add("wth2-faqButton");
		 	   		/*if(k===0 || k % 2 === 0){
		 	   			newButton.classList.add("wth2-cssLogin_faqButtonPadding");
		 	   		} 
		 	   		if(buttonCollection.categories.length % 2 > 0){
			 	   			if(buttonCollection.categories.length===k+1){
			 	   				newButton.classList.add("wth2-faqButtonFull");
			 	   			}
				 	   		else{
				 	   			newButton.classList.add("wth2-faqButton");
				 	   		}
			 	   		}
			 	   		else{
			 	   			newButton.classList.add("wth2-faqButton");
			 	   		}*/
			 	   		document.getElementById("faqButtonContainerWrapper").appendChild(newButton);
		 	   		}
	   		   
	   	        }
	   	    
	   	}
	   	xhttp.send();	  
   }
    getStoreAttValue = (attCode) => {
    	let storeAttributeValue='';
    	for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
    		if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
    			storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
    		}
    	}
    	return storeAttributeValue;
    }

    render = () => {
        return (<div>{this.faqButtonService()}</div>);            
    }

}
export default FaqButtonService;
